import { gql } from "@apollo/client";

export const GET_ALL_EXAM_PAPERS = gql`
  query getExamPapers($input: GetExamPapersFilterInput!) {
    getExamPapers(input: $input) {
      examPapers {
        id
        title
        questionPaperPublicPdfUrl
        scheduledDate
        totalSections
        totalMarks
        totalQuestions
        questionTypes
        bloomsTaxonomyOne
        bloomsTaxonomyTwo
        isArchived
        isAutogradeEnabled
        isAutomarksEnabled
        createdById
        updatedById
        createdAt
        updatedAt
        createdByName
        updatedByName
      }
      totalRecords
    }
  }
`;

export const GET_ALL_EXAM_PAPERS_ANSWER_KEY = gql`
  query getExamPaperAnswerKeys($input: GetExamPaperAnswerKeysFilterInput!) {
    getExamPaperAnswerKeys(input: $input) {
      examPaperAnswerKeys {
        id
        examPaperId
        answerKeyPublicPdfUrl
        isArchived
        mode
        createdById
        updatedById
        createdAt
        updatedAt
        createdByName
        updatedByName
      }
      totalRecords
    }
  }
`;

// export const GET_ALL_EXAM_PAPERS_SUBJECTS = gql`
//   query getExamPaperSubjects($input: GetExamPaperSubjectsFilterInput!) {
//     getExamPaperSubjects(input: $input) {
//       examPaperSubjects {
//         createdAt
//         createdById
//         createdByName
//         examPaperId
//         id
//         isArchived
//         subjectId
//         updatedAt
//         updatedById
//         updatedByName
//       }
//       totalRecords
//     }
//   }
// `;

export const GET_ALL_EXAM_PAPERS_DELIVERY = gql`
  query getExamPaperDeliveries($input: GetExamPaperDeliveriesFilterInput!) {
    getExamPaperDeliveries(input: $input) {
      examPaperDeliveries {
        academicYearIds
        academicYearNames
        batchIds
        batchNames
        boardIds
        boardNames
        classIds
        classNames
        collegeIds
        createdAt
        collegeNames
        createdById
        createdByName
        deliveryExecutionCount
        examPaperId
        id
        isArchieved
        sortOrder
        source
        updatedAt
        updatedById
        updatedByName
      }
      totalRecords
    }
  }
`;

export const GET_ALL_EXAM_PAPERS_DELIVERY_EXICUTION = gql`
  query getExamPaperDeliveryExecutions(
    $input: GetExamPaperDeliveryExicutionRequest!
  ) {
    getExamPaperDeliveryExecutions(input: $input) {
      examPaperDeliveryExecutions {
        id
        examPaperDeliveryId
        deliveryExecutionCount
        studentObjectId
        studentName
        collegeObjectId
        collegeName
        classObjectId
        className
        batchObjectId
        batchName
        boardObjectId
        boardName
        acadamicObjectId
        acadamicYearName
        isArchieved
        createdById
        createdByName
        updatedById
        updatedByName
        createdAt
        updatedAt
      }
      totalRecords
    }
  }
`;

export const GET_PRESIGNED_URL = gql`
  query getPresignedUrl(
    $objectName: String!
    $usecase: String!
    $expiration: Int!
  ) {
    getPresignedUrl(
      objectName: $objectName
      usecase: $usecase
      expiration: $expiration
    )
  }
`;

export const GET_SUBJECTS = gql`
  query getsubjects($input: GetPresignedPutUrlRequest!) {
    getsubjects(input: $input) {
      id
      name
    }
  }
`;

export const GET_CHAPTERS = gql`
  query getChapters($input: GetPresignedPutUrlRequest!) {
    getChapters(input: $input) {
      id
      name
    }
  }
`;

export const GET_TOPICS = gql`
  query getChapters($input: GetPresignedPutUrlRequest!) {
    getChapters(input: $input) {
      presignedPutUrl
    }
  }
`;

export const GET_COLLAGES = gql`
  query getTopics($input: GetPresignedPutUrlRequest!) {
    getTopics(input: $input) {
      id
      name
    }
  }
`;

export const GET_ACADEMIC_YEARS = gql`
  query getPresignedUrl($input: GetPresignedPutUrlRequest!) {
    getPresignedUrl(input: $input) {
      presignedPutUrl
    }
  }
`;

export const GET_BATCHES = gql`
  query getPresignedUrl($input: GetPresignedPutUrlRequest!) {
    getPresignedUrl(input: $input) {
      presignedPutUrl
    }
  }
`;

export const GET_CLASSES = gql`
  query getPresignedUrl($input: GetPresignedPutUrlRequest!) {
    getPresignedUrl(input: $input) {
      presignedPutUrl
    }
  }
`;

export const GET_BOARDS = gql`
  query getPresignedUrl($input: GetPresignedPutUrlRequest!) {
    getPresignedUrl(input: $input) {
      presignedPutUrl
    }
  }
`;

export const GET_ALL_EXAM_PAPERS_QUESTIONS = gql`
  query getExamPaperQuestions($input: GetExamPaperQuestionsFilterInput!) {
    getExamPaperQuestions(input: $input) {
      examPaperQuestions {
        id
        examPaperId
        questionNumber
        questionType
        marks
        nodeType
        choiceCount
        sectionTitle
        sectionOrder
        subjectName
        chapterName
        topicName
        createdByName
        createdAt
        updatedByName
        updatedAt
      }
      totalRecords
    }
  }
`;


export const GET_ALL_EXAM_PAPERS_SUBJECTS = gql`
  query getExamPaperSubjects($input: GetExamPaperSubjectsFilterInput!) {
    getExamPaperSubjects(input: $input) {
      examPaperSubjects {
        id
        examPaperId
        subjectId
        isArchived
        createdAt
        createdByName
        updatedAt
        updatedByName
      }
      totalRecords
    }
  }
`;